module.exports = "<p>The BRCA Exchange aims to advance our understanding of the genetic basis of breast, ovarian, prostate, pancreatic and other cancers by pooling data on BRCA1/2 genetic variants and corresponding clinical data from around the world. Search for BRCA1 or BRCA2 variants above.</p><p>This website is a product of the BRCA Challenge project, a driver project of the Global Alliance for Genomics and Health.</p>";


//////////////////
// WEBPACK FOOTER
// ./content/home.md
// module id = 1282
// module chunks = 0